import angular from 'angular';

angular.module('selectbox').directive('selectbox', selectbox);

selectbox.$inject = ['$timeout'];

function selectbox($timeout) {
  var directive = {
    require: 'ngModel',
    bindToController: true,
    controller: 'selectboxCtrl',
    controllerAs: 'vm',
    templateUrl: templateUrl,
    link: link,
    restrict: 'AE',
    transclude: true,
    scope: {
      options: '=ngOptions',
      model: '=ngModel',
      change: '&ngChange',
      locked: '=locked',
    },
  };
  return directive;

  function link(scope, element, attrs, ngModel) {
    scope.$watch(
      function () {
        return ngModel.$modelValue;
      },
      function (newValue, oldValue) {
        $timeout(scope.vm.change, 0);
      },
      true,
    );

    scope.$watch(
      'vm.options',
      function (newVal, oldVal) {
        if (newVal != oldVal) {
          $timeout(function () {
            $('select', element).trigger('refresh');
          }, 0);
        }
      },
      true,
    );

    scope.$watch(
      'vm.model',
      function (newVal, oldVal) {
        if (newVal != oldVal) {
          $timeout(function () {
            $('select', element).trigger('refresh');
          }, 0);
        }
      },
      true,
    );

    scope.$watch(
      'vm.locked',
      function (newVal, oldVal) {
        if (newVal) {
          $timeout(function () {
            $('select', element).prop('disabled', true);
            $('select', element).trigger('refresh');
          }, 0);
        } else {
          $timeout(function () {
            $('select', element).prop('disabled', false);
            $('select', element).trigger('refresh');
          }, 0);
        }
      },
      true,
    );

    $timeout(function () {
      var select = $('select', element);
      select.styler();
    }, 0);
  }

  function templateUrl(elem, attrs) {
    return (
      attrs.templateUrl ||
      new URL('app/selectbox/selectbox.html?raw', import.meta.url)
    );
  }
}
